import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ServiceOrder } from '../../Serviceorder/models/service-order';
import { ServiceOrderService } from '../../Service/service-order-service';
import { ServiceorderEdit } from '../serviceorder-edit/serviceorder-edit';
import { ToastService } from '../../Service/toast-service';
import { SignatureDialog } from '../signature-dialog/signature-dialog';

@Component({
  selector: 'app-serviceorder-list',
  imports: [CommonModule, RouterOutlet, FormsModule, MatDialogModule],
  templateUrl: './serviceorder-list.html',
  styleUrl: './serviceorder-list.css',
})
export class ServiceorderList implements OnInit {

  // 📋 Colecciones de datos homologadas con tipado estricto
  public serviceOrders: ServiceOrder[] = [];
  public ordenesFiltradas: ServiceOrder[] = [];
  public filtroTexto: string = '';

  // 🧭 Paginación reactiva adaptada al estándar de velocidad JDE de tu taller
  public paginaActual: number = 1;
  public registrosPorPagina: number = 10;
  public totalPaginas: number = 1;

  protected readonly Math = Math;

  constructor(
    private serviceOrderService : ServiceOrderService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public toastService: ToastService,
  ){}

  ngOnInit(): void {
    this.listServiceOrders();
  }

  public listServiceOrders(): void {
    console.log('>>> [ERP JDE] Descargando pipeline operativo de órdenes de trabajo...');
    this.serviceOrderService.getServiceOrderList().subscribe({
      next: (data: ServiceOrder[]) => {
        this.serviceOrders = data || [];
        this.ordenesFiltradas = [...this.serviceOrders];
        this.calcularTotalPaginas();
        this.cdr.detectChanges();
      },
      error: (err) => console.error('🚨 Error al sincronizar el pipeline de taller:', err)
    });
  }

  public filtrarOrdenes(): void {
    const busqueda = this.filtroTexto.trim().toUpperCase();
    if (!busqueda) {
      this.ordenesFiltradas = [...this.serviceOrders];
    } else {
      this.ordenesFiltradas = this.serviceOrders.filter(o => {
        // 🛡️ Evaluación segura tolerante a valores nulos o primitivos numéricos
        const idTexto = o.id ? o.id.toString() : '';
        const tecnicoTexto = o.an8Tecnico ? o.an8Tecnico.toString() : 'SIN ASIGNAR';
        const estatusTrabajo = o.orderStatus ? o.orderStatus.toUpperCase() : '';
        const estadoAdmvo = o.status ? o.status.toUpperCase() : '';

        return idTexto.includes(busqueda) ||
               tecnicoTexto.includes(busqueda) ||
               estatusTrabajo.includes(busqueda) ||
               estadoAdmvo.includes(busqueda);
      });
    }
    this.paginaActual = 1;
    this.calcularTotalPaginas();
    this.cdr.detectChanges();
  }

  public deleteServiceOrder(id: number): void {
    if (confirm('¿Está seguro de eliminar esta orden de trabajo de las rampas? Esta acción alterará el pipeline operativo.')) {
      console.log('Selected serviceOrder ID para eliminación física:', id);
      this.serviceOrderService.deleteServiceOrderById(id).subscribe({
        next: () => {
          this.listServiceOrders();
        },
        error: (err) => console.error('Error al remover orden:', err)
      });
    }
  }

  // 🚀 CONSERVADO: Tu motor original de edición por bloques en diálogo modal MatDialog
  public editServiceOrder(serviceOrder: ServiceOrder): void {
    const dialogRef = this.dialog.open(ServiceorderEdit, {
      data: serviceOrder, 
      width: '900px', 
      height: '1000px', 
      panelClass: 'custom-dialog-container' 
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log("🎯 [SaaS Taller] Retorno de modal cerrado exitosamente. ID:", result.id);
        
        const index = this.serviceOrders.findIndex(c => c.id === result.id);
        if (index !== -1) {
          this.serviceOrders[index] = result;
        }
        
        // Refrescamos de inmediato las consultas en red para ver los cambios contables y de técnicos
        this.listServiceOrders();
      }
    });
  }

  public calcularTotalPaginas(): void {
    this.totalPaginas = Math.ceil(this.ordenesFiltradas.length / this.registrosPorPagina) || 1;
  }

  public cambiarPagina(nuevaPagina: number): void {
    if (nuevaPagina >= 1 && nuevaPagina <= this.totalPaginas) {
      this.paginaActual = nuevaPagina;
      this.cdr.detectChanges();
    }
  }

  get ordenesPaginadas(): ServiceOrder[] {
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    return this.ordenesFiltradas.slice(inicio, inicio + this.registrosPorPagina);
  }

  public lanzarFirmaEntregaFinal(orden: ServiceOrder): void {
    console.log(`⚖️ [SaaS Legal] Iniciando Firma 3 (Entrega de Unidad) para OS ID: ${orden.id}`);

    const dialogRef = this.dialog.open(SignatureDialog, {
      width: '840px',
      disableClose: true, // Candado preventivo de salida en tablets de rampa
      data: {
        idRecepcion: orden.idRecepcion, // Vinculación FK de patio
        folioRecepcion: 'OS-' + orden.id,
        an8Cliente: orden.an8Cliente,
        etapaFirma: 'ENTREGA' // 🚀 INYECTADO: Le indica a tu API e HTML de Signals que es el acta de salida
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastService.showSuccess('Workflow Concluido', 'El acta de entrega fue sellada y el expediente fue archivado.');
        this.listServiceOrders(); // Recarga la matriz operativa en caliente
      }
    });
  }

}
